export enum ImportExportDialogModes {
  Import = 'import',
  Export = 'export'
}

export enum DialogEntities {
  Project = 'project',
  ServiceStack = 'service-stack'
}
